import { CORRELATION_CARD, EVOLUTIVE_CARD, EVOLUTIVE_CROSS_CARD, MULTIPLE_CARD, SIMPLE_CARD } from 'src/sections/GroupCards/cardTypes';
import { BAR, PIE, FUNNEL, PIE_GRADE, TREE_MAP, SIMPLE_BUBBLE, GRAPH_BUBBLE } from 'src/components/Charts/types';

function getDefaultEnunciado(options, clickedItemIndex) {
  return options.series[clickedItemIndex].name;
}

function getCustomEnunciado(options, clickedItemIndex) {
  return options.series[0] && options.series[0].data[clickedItemIndex].name;
}

function getEvolutiveBarEnunciado(options, clickedItemIndex) {
  return options.dataset.source[1 + clickedItemIndex][0];
}

// Para todos os gráficos de correlação, `option.legend.data` armazena a lista canônica
// de enunciados de perguntas correlacionadas — o índice do item clicado vem do
// contextIndexResolver e é resolvido aqui no enunciado correspondente.
function getCorrelationEnunciado(options, clickedItemIndex) {
  return options && options.legend && options.legend.data
    ? options.legend.data[clickedItemIndex]
    : null;
}

const enunciadoByChartType = {
  [`${SIMPLE_CARD}_${PIE}`]: getCustomEnunciado,
  [`${MULTIPLE_CARD}_${PIE}`]: getCustomEnunciado,
  [`${SIMPLE_CARD}_${FUNNEL}`]: getCustomEnunciado,
  [`${SIMPLE_CARD}_${PIE_GRADE}`]: getCustomEnunciado,

  [`${EVOLUTIVE_CARD}_${BAR}`]: getEvolutiveBarEnunciado,
  [`${EVOLUTIVE_CROSS_CARD}_${BAR}`]: getEvolutiveBarEnunciado,

  [`${CORRELATION_CARD}_${TREE_MAP}`]: getCorrelationEnunciado,
  [`${CORRELATION_CARD}_${SIMPLE_BUBBLE}`]: getCorrelationEnunciado,
  [`${CORRELATION_CARD}_${GRAPH_BUBBLE}`]: getCorrelationEnunciado,

  default: getDefaultEnunciado,
};

/**
 * Recupera o enunciado da alternativa selecionada pelo usuário ao fazer uma mudança de cores
 * em algum item do gráfico, primeiro uma verificação de estratégia é feita de acordo com o tipo
 * do gráfico, pois a forma de obter este enunciado varia dependendo do tipo de gráfico manipulado.
 * @param {string} identifier Tipo do gráfico atualmente manipulado
 * @param {object} echartOption Objeto de configuração do gráfico (EChartOption)
 * @param {number} clickedItemIndex Índice do item clicado do gráfico no objeto de series
 * @returns {string} Enunciado da alternativa correspondente ao item clicado pelo usuário
 */
export default function getEnunciadoStrategyByChartType(identifier, echartOption, clickedItemIndex) {
  const enunciadoStrategy = enunciadoByChartType[identifier] || enunciadoByChartType.default;

  return enunciadoStrategy(echartOption, clickedItemIndex);
}
